import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  loading: false,
  trustValidationResult: {
    abn: null,
    isValidated: false,
    isEligible: false,
    message: null,
  },
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_TRUST_VALIDATION_RESULT]: (state, { payload }) => ({
      ...state,
      trustValidationResult: payload,
    }),
    [actionTypes.RESET_TRUST_VALIDATION_RESULT]: (state) => ({
      ...state,
      trustValidationResult: initialState.trustValidationResult,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
